import isNill from "lodash/fp/isNil";

class Controller {
  constructor(Events, $element) {
    "ngInject";
    this.Events = Events;
    this.$element = $element;
    this.searchTerm = "";
  }

  $onInit() {
    const updateEvent = this.eventName;
    const changed = Object.assign({}, this.selected);

    this.enableField = () => {
      this.selected.isDisabled = false;
    };
    this.submitField = () => {
      if (!isNill(this.errorMsg) && isNill(this.selected)) return; // If required and empty do nothing
      const options = Object.assign({}, changed, this.selected);
      options.value = this.multiple
        ? [...this.selected]
        : options.name === ""
        ? null
        : options.name;
      options.method = this.resourceMethod;
      options.methodName = this.resourceMethodName;
      options.key = this.name || options.key;
      if (this.extraParams) options.extraParams = this.extraParams;
      this.Events.emit(updateEvent, options);
    };
    this.onChange = (value) => {
      if (this.onFieldChangeEvent && !value.isDisabled) {
        this.Events.emit(this.onFieldChangeEvent, {
          value,
          extraParams: this.extraParams,
        });
      }
    };
  }
  $onChanges() {
    this.$element.find("input").on("keydown", (ev) => {
      ev.stopPropagation();
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableSelect/editableSelect.controller.js